import watchSetRange from './setRange';
import watchUpdateRange from './updateRange';

const watchEditRange = [watchSetRange, watchUpdateRange];

export default watchEditRange;
